import React, { Component } from 'react';
import { Link } from 'react-router-dom'
import { Card } from 'antd'
import './style.css'
class CardObj extends Component {
    render() {
        let { event } = this.props 
        return (
            <Card style={{textAlign: "center"}}>
                <Link to={`/${event.slug}`} >
                    <div className="body-card" >
                        <img src={event.logoFMImage} alt={event.logoFMImage} className="img"/>
                    </div>
                <div className="bottom-card">
                    <h3>{event.title}</h3>
                    <p>{event.date}</p>
                </div>
                </Link>
            </Card>
        )
    }
}

export default CardObj


// WEBPACK FOOTER //
// ./src/Home/Component/CardObj.js